import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Observable, concat, combineLatest, merge } from 'rxjs';
import * as fromUser from '../../user-info';
import { Store, select } from '@ngrx/store';
import { ProcessCategory } from '../ProcessCategory.model';
import { reduce, map, withLatestFrom, mergeAll } from 'rxjs/operators';

@Component({
    selector: 'ef-help-desk-feature',
    templateUrl: './help-desk-feature.component.html',
    styleUrls: ['./help-desk-feature.component.scss'],
    standalone: false
})
export class HelpDeskFeatureComponent implements OnInit, AfterViewInit {
    public processesCategories$: Observable<Array<ProcessCategory>>;
    constructor(private userStore: Store<fromUser.State>) {}

    ngOnInit() {
        this.setupObservables();
    }

    ngAfterViewInit(): void {}

    setupObservables() {
        const userCategories = this.userStore.pipe(
            select(fromUser.getUserProcessesMain),
            map(processes =>
                processes.map(
                    process =>
                        ({
                            CategoryId: 0,
                            CategoryName: 'General',
                            ...process
                        } as ProcessCategory)
                )
            )
        );
        const mainCategories = this.userStore.pipe(
            select(fromUser.getUserProcessCategories),
            map(categories =>
                categories.reduce(
                    (a, c) =>
                        a.concat(
                            c.UserProcesses.map(p => ({
                                CategoryId: c.CategoryId,
                                CategoryName: c.CategoryName,
                                ...p
                            }))
                        ),
                    [] as ProcessCategory[]
                )
            )
        );
        this.processesCategories$ = userCategories.pipe(
            withLatestFrom(mainCategories),
            map(([x, y]) => x.concat(y))
        );
    }
}
